import styled from 'styled-components';
import bgImage from '../../assets/images/bg_login.jpg';
import { styleSheet } from '../../assets/styles/global';
import { Link } from 'react-router-dom';

interface IButtonLogin {
  isLoading: boolean;
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;

  background-image: url(${bgImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

export const MainLogo = styled.img`
  width: 8rem;
  margin-bottom: 4rem;
`;

export const Modal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 5rem 3rem;
  background: rgba(255, 255, 255, 0.9);
  width: 40rem;
  border-radius: 3rem;
`;

export const FormContainer = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

`;

export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  width: 100%;
`;

export const FormLabel = styled.label`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #2c2c2c;
`;

export const ButtonLogin = styled.button<IButtonLogin>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 3rem;
  font-size: 1.8rem;
  width: 70%;
  margin-top: 3rem;

  background: ${styleSheet.colorMain};
  color: ${styleSheet.shape};
  border: 0;
  border-radius: 0.8rem;
  cursor: pointer;
  transition: 0.2s background ease-out;

  opacity: ${({ isLoading }) => isLoading ? 0.4 : 1};

  &:hover {
    background: ${styleSheet.colorMainDark}
  }
`;

export const InputLogin = styled.input`
  display: flex;
  padding: 1rem;
  font-size: 1.6rem;
  border-radius: 0.8rem;
  border: 0.1rem solid #c3c3c3;
`;

export const CodeContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 15%);
  grid-gap: 1.5%;
`;

export const InputCode = styled.input.attrs({
  maxLength: 1
})`
  height: 50px;
  width: 100%;
  font-size: 24px;
  text-align: center;
`;

export const ContainerForget = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 1rem;

  font-size: 1.6rem;
`;


export const LinkForgotPass = styled(Link)`
  text-decoration: none;
  color: ${styleSheet.colorMain};
  transform: 0.2s color ease-out;

  &:hover {
    color: ${styleSheet.colorMainDark};
  }
`;

export const ResendCodeLink = styled.span`
  text-decoration: none;
  color: ${styleSheet.colorMain};
  transform: 0.2s color ease-out;
  cursor: pointer;

  &:hover {
    color: ${styleSheet.colorMainDark};
  }
`;

export const ResendCodeText = styled.p`
  margin-top: 1rem;
  font-size: 1.8rem;
  color: '#000';
`;

export const MessageInfo = styled.p`
  font-size: 1.8rem;
`;

